import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
// import "./libs/odometer";

import { binder } from "./libs/binder";
import { constants } from "./modules/module";
import { fullHeightPage } from "./modules/fullHeightPage";
import { stickyHeader } from "./modules/stickyHeader";
import { mobileNav } from "./modules/mobileNav";
import { animationOnScroll } from "./modules/animationOnScroll";
import { countersAnimation } from "./modules/countersAnimation";
import { scrollDown } from "./modules/scrollDown";
import { scrollTop } from "./modules/scrollTop";
import { teamSlider } from "./modules/teamSlider";
import { loadMoreTeam } from "./modules/loadMoreTeam";
import { skipContent } from "./modules/skipContent";
import { accordion } from "./modules/accordion";
import { imagesSlider } from "./modules/imagesSlider";
import { copyLinkToBuffer } from "./modules/copyLinkToBuffer";
import { quoteSlider } from "./modules/quoteSlider";
import { showMoreLogos } from "./modules/showMoreLogos";
import { heroSlider } from "./modules/heroSlider";
import { map } from "./modules/map";
import { customSelect } from "./modules/customSelect";
import { textAnimation } from "./modules/textAnimation.js";
import {tableWrap} from "./modules/tableWrap";
import { customAudio } from "./modules/customAudio.js";
import { customVideo } from "./modules/customVideo.js";
//import { customPDF } from "./modules/customPDF.js";

binder({
    bounds: {
        "html": [constants, fullHeightPage],
        ".header": [stickyHeader, mobileNav],
        ".has-animation": animationOnScroll,
        ".has-counters-animation": countersAnimation,
        ".scroll-down-button": scrollDown,
        ".scroll-to-top": scrollTop,
        ".team-list": [teamSlider, loadMoreTeam],
        ".skip-content": skipContent,
        ".accordion": accordion,
        ".images-slider": imagesSlider,
        ".copy-link": copyLinkToBuffer,
        ".quote-slider": quoteSlider,
        ".logos-grid": showMoreLogos,
        ".hero-slider": heroSlider,
        "select": customSelect,
        ".map-section": map,
        ".split-text": textAnimation,
        "table": tableWrap,
        ".audio-block .audio-wrap": customAudio,
        ".video-block .video-wrap": customVideo,
    //    ".pdf-custom-block .pdf-viewer": customPDF,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js